<template>
  <div id="dashboard-candidate">
    <div class="container has-nav-top-margin">
      <profile-candidate
        :profile="user.profile"
        :account="user.account"
        @refreshProfile="refreshProfile"
      />
    </div>
  </div>
</template>

<script>
import ProfileCandidate from '@/components/CandidateProfile/ProfileCandidate';

export default {
  name: 'DashboardCandidate',
  components: {
    ProfileCandidate
  },
  computed: {
    user () {
      return this.$store.state.user;
    }
  },
  methods: {
    refreshProfile () {
      this.$store
        .dispatch('refreshCandidateProfile')
        .then(response => {
          if (response.data.status === 'success') {
            this.$toasted.show('Changes discarded...');
          } else {
            this.$toasted.show(
              'Oops, there was an error performing this action.'
            );
          }
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 1280px) and (min-width: 1472px) {
  .container {
    max-width: 960px;
  }
}
</style>
